// let isAnimateActive = true;
//
// /**
//  * Блокировка скролла
//  */
// function noScroll() {
//     window.scrollTo(0, 0);
// }
//
// function animateLoaderFill () {
//     if (!isAnimateActive) {
//         return false;
//     }
//     $('.preloader-label-fill').animate({
//         width: '120%',
//     }, 500, function () {
//         $('.preloader-label-fill').animate({
//             left: '200px',
//         }, 700, function () {
//             $('.preloader-label-fill').css({
//                 left: '-10px',
//                 width: 0
//             });
//
//             animateLoaderFill();
//         });
//     });
// }
//
// $(document).ready(function () {
//     window.addEventListener('scroll', noScroll);
//
//     animateLoaderFill();
// });
//
// $(window).on('load', function () {
//     const animationIn = {
//         effect: 'fadeInUp',
//         sync: true,
//         shuffle: false,
//         reverse: true,
//     };
//
//     const animationOut = {
//         effect: 'fadeOutUp',
//         sync: true,
//         shuffle: false,
//         reverse: true,
//     };
//
//     setTimeout(function() {
//         isAnimateActive = false;
//
//         $('#preloader__title-line-1').css({opacity: 1}).textillate({
//             in: animationIn,
//             out: animationOut,
//             initialDelay: 600,
//         });
//
//         $('#preloader__title-line-2').css({opacity: 1}).textillate({
//             in: animationIn,
//             out: animationOut,
//             initialDelay: 700,
//         });
//
//         $('#preloader__title-line-3').css({opacity: 1}).textillate({
//             in: animationIn,
//             out: animationOut,
//             initialDelay: 800,
//         });
//
//         $('#preloader__title-line-4').css({opacity: 1}).textillate({
//             in: animationIn,
//             initialDelay: 900,
//             out: {
//                 effect: 'fadeOutUp',
//                 sync: true,
//                 shuffle: false,
//                 reverse: true,
//                 callback: function () {
//                     $('.preloader').slideUp(500);
//                 }
//             },
//             callback: function () {
//                 $('.preloader-container').delay(1000).animate({
//                     width: `${$('.preloader-container').width() - 100}px`,
//                 }, 500, function () {
//                     $('#preloader__title-line-1').textillate('out');
//                     $('#preloader__title-line-2').textillate('out');
//                     $('#preloader__title-line-3').textillate('out');
//                     $('#preloader__title-line-4').textillate('out');
//                     window.removeEventListener('scroll', noScroll);
//                 });
//             }
//         });
//     }, 1500);
// });